export default {
  'license.energyInsights': 'Energy insights',
  'license.small': 'Small',
  'license.medium': 'Medium',
  'license.enterprise': 'Enterprise',

  'moduleGroup.audit': 'Marktplaats',
  'moduleGroup.dataAccess': 'Data toegang',
  'moduleGroup.general': 'Varia',
  'moduleGroup.services': 'Services',
  'moduleGroup.sustainability': 'Duurzaamheid',
  'moduleGroup.sustainability.enterprise': 'Duurzaamheid - Enterprise',

  'module.oData': 'OData',
  'module.restApi': 'REST Api',
  'module.dataReadiness': 'Data Readiness',
  'module.csrd': 'CSRD (Corporate Sustainability Reporting Directive)',
  'module.esg': 'ESG (Environment Social Governance)',
  'module.ghg': 'GHG (Greenhouse Gas Protocol)',
  'module.ghg.scope3': 'GHG Scope 3',
  'module.gri': 'GRI (Global Reporting Initiative)',
  'module.sbti': 'SBTi (Science Based Targets initiative)',
  'module.sdg': 'SDG (Sustainable Development Goals)',
  'module.dataAccess.oData': 'OData',
  'module.dataAccess.restApi': 'REST API',
  'module.smsModule': 'SMS',
  'module.inviteCompany': 'Bedrijven uitnodigen',
  'module.audit': 'Sustainability AUDIT',
  'module.enquiry': 'Sustainability ENQUIRY',

  'quota.maxSites': 'Max sites',
  'quota.maxUsers': 'Max gebruikers',
  'quota.smsLimit': 'SMS limiet',
  'quota.maxDatapoints': 'Max datapunten',
  'quota.maxDataposts': 'Max dataposts',
}
